var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "pa-0 mt-2", attrs: { rounded: "md", flat: "" } },
    [
      _vm.account.logo
        ? _c(
            "v-card-title",
            [
              _c(
                "v-row",
                { staticClass: "px-3 pt-5", attrs: { justify: "center" } },
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "overflow-hidden",
                      attrs: { width: "90", outlined: "" },
                    },
                    [
                      _c(
                        "v-responsive",
                        {
                          staticClass: "align-center",
                          attrs: { "aspect-ratio": 1 / 1 },
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "px-1",
                              attrs: { color: "white", width: "90" },
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: _vm.account.logo.split(/[?#]/)[0],
                                  width: "100%",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card-subtitle",
        { staticClass: "white-0" },
        [
          _c(
            "v-row",
            {
              style: `width: ${
                _vm.$vuetify.breakpoint.width < 1270 ? 465 : 564
              }px;`,
            },
            [
              _c(
                "v-col",
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-block text-h4 grey-700--text font-weight-bold mt-1",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.activeDocument.name) +
                          " Nº " +
                          _vm._s(_vm.instance.number) +
                          " "
                      ),
                    ]
                  ),
                  _c("v-col", { staticClass: "text-left mt-2" }, [
                    _c(
                      "span",
                      { staticClass: "body-1 grey-700--text font-weight-bold" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-weight-bold body-1 grey-700--text",
                          },
                          [_vm._v("De:")]
                        ),
                        _vm._v(" " + _vm._s(_vm.account.name)),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass:
                          "d-block body-1 grey-700--text font-weight-regular pt-1",
                      },
                      [
                        _vm._v(
                          "Para: " +
                            _vm._s(((_vm.instance || {}).taxpayer || {}).name)
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        {
          style: `width: ${
            _vm.$vuetify.breakpoint.width < 1270 ? 465 : 564
          }px;`,
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "px-0 pb-1", attrs: { cols: "12" } },
                [
                  _c("v-textarea", {
                    staticClass: "elevation-0",
                    attrs: {
                      placeholder: _vm.placeholder,
                      "auto-grow": "",
                      solo: "",
                      flat: "",
                      "hide-details": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateMessage($event)
                      },
                    },
                    model: {
                      value: _vm.messageBody,
                      callback: function ($$v) {
                        _vm.messageBody = $$v
                      },
                      expression: "messageBody",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }